export * from '@fortawesome/free-solid-svg-icons';